import "../../../../styles/productViewItem.scss";

import Icon, { iconTypes } from "../../../common/components/Icon";
import {canWorkWithOrder, countAddedProduct, countWhat, getProductOrderProperty, getSalesLineId} from "../../util/orderUtil.js";

import { Localization } from "../../../common/util/localization.jsx";
import ProductViewModal from "../product/ProductViewModal";
import PropTypes from "prop-types";
import React from "react";

// Component for displaying product info in a table with one or more rows (eg product search)
// Each product is displayed in a form consisting of an image and information below it.
class ProductViewItem extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            showModal: false,
        };

        this.change = this.change.bind(this);
        this.showProductModal = this.showProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
    }
    UNSAFE_componentWillMount() {
        
    }
    change(change) {
        const {
            addRemoveProductToTemporaryOrder,
            product,
        } = this.props;
        //
        addRemoveProductToTemporaryOrder(product, change.value, change.salesLineId);
    }
    showProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        const {
            localization,
            product,
            activeOrder,
            setModal,
            onMyListEdit,
        } = this.props;

        setModal(<ProductViewModal localization={localization} product={product} activeOrder={activeOrder} onAddProductChange={this.change} onCloseModal={this.closeProductModal} width={460} onMyListEdit={onMyListEdit}/>);
    }
    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.setModal(null);
    }
    render(){
        const {
            disabled,
            localization,
            product,
            activeOrder,
            countProductsInList,
            countingNode,
        } = this.props;

        const isLocked = getProductOrderProperty(activeOrder, product.productId, "isLocked"); //|| getProductOrderProperty(activeOrder, product.productId, "isKitMember");
        const hasWarning = getProductOrderProperty(activeOrder, product.productId, "warningText")!=null;
        const hasError = getProductOrderProperty(activeOrder, product.productId, "errorText")!=null;
        const canEdit = canWorkWithOrder(activeOrder) && !disabled && !isLocked && !product.notActive;
        const added = countProductsInList?countProductsInList(activeOrder, product.productId):countAddedProduct(activeOrder, product.productId, countWhat.everything);
        const salesLineId = getSalesLineId(activeOrder, product.productId, true);
        const minValue = getProductOrderProperty(activeOrder, product.productId, "mustOrderAtLeastOne")?1:0;
        const isOpenDistribution = getProductOrderProperty(activeOrder, product.productId, "isOpenDistributionLine");

        const countingNodeWithProps = React.cloneElement(countingNode, {onEdit:this.change, value:added, salesLineId:salesLineId, disabled:!canEdit, minValue:minValue, product, activeOrder, notActive: product.notActive, notActiveText: product.notActiveText});
        const priceOrDiscount = (product.campaignDiscount ? `-${product.campaignDiscount.toFixed(2)}%` : product.price.toFixed(2));

        return (
            <div className={"product-view-item-wrapper"} >
                <div className={"item-container"}>
                    
                    <div className={"item-image-background"} onClick={this.showProductModal}>
                        {product.imageUrl && (
                            <React.Fragment>
                                <img src={product.imageUrl} className="image"/>
                                <div className="warning-wrapper">
                                    {isLocked && (
                                        <div className="warning-bg">
                                            <Icon type={iconTypes.lockLocked} className="lock"/>
                                        </div>
                                    )}
                                    {isOpenDistribution && (
                                        <div className="warning-bg">
                                            <Icon type={iconTypes.lockUnlocked} className="lock"/>
                                        </div>
                                    )}
                                    {minValue===1 && (
                                        <div className="warning-bg">
                                            <Icon type={iconTypes.lockOneLocked} className="lock"/>
                                        </div>
                                    )}
                                    {hasWarning && (
                                        <div className="warning-bg">
                                            <Icon type={iconTypes.warningTiny} className="lock"/>
                                        </div>
                                    )}
                                    {hasError && (
                                        <div className="warning-bg">
                                            <Icon type={iconTypes.errorTiny} className="lock"/>
                                        </div>
                                    )}
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                    <div className={"info"}>
                        <div className="counter-field">
                            {countingNodeWithProps}
                        </div>
                        <div className="label14 prd-name" onClick={this.showProductModal}>
                            {product.productName}
                        </div>
                        <div className="detail">
                            <div className="label12 pack-size">
                                {localization.text("order","packSize",{noOfSalesUnits:product.noOfSalesUnits})}
                            </div>
                            <div className="label16 price">
                                {priceOrDiscount}
                            </div>
                            <div className="label12 pack-size">
                                {localization.text("order","epdInfo",{epdNo:product.epdNo})}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ProductViewItem.propTypes = {
    localization: Localization.propTypes.isRequired,
    product: PropTypes.object.isRequired,
    activeOrder: PropTypes.object.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    countingNode: PropTypes.node.isRequired,
    countProductsInList: PropTypes.func,
    disabled: PropTypes.bool,
    onMyListEdit: PropTypes.func,
};
ProductViewItem.defaultProps = {
};

export default ProductViewItem;